export default __webpack_public_path__ + "static/userJoin3-2cdd205177fe3dc16c828303798824d5.jpg";